<header class="header flex flexJustify-between flexAlign-center">

  <div class="header__main">
    <app-logo></app-logo>

    <app-campaign-switcher class="main-header-switcher"></app-campaign-switcher>

    <div class="header__main--nav">
      <app-support-card></app-support-card>

      <app-user-profile-card></app-user-profile-card>
    </div>
  </div>

  <div class="header__banner banner">
    <span class="banner__org">
      <span class="banner__context">Administration</span>
    </span>
  </div>

  <nav class="primaryNav col__  primaryNav--admin"
       mat-tab-nav-bar
       mat-stretch-tabs="false"
       mat-align-tabs="start"
       [tabPanel]="tabPanel">
    <a *appIfMinRole="'lead'"
       class="primaryNav__link"
       routerLink="/campaign/list"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-sitemap primaryNav__icon primaryNav__icon--blue fa-fw mr-0050"></i>
      <span class="primaryNav__label">Campaigns</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'lead'"
       routerLink="/admin/account"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-users primaryNav__icon primaryNav__icon--magenta fa-fw mr-0050"></i>
      <span class="primaryNav__label">Users</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/entity-types"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-dice-d20 primaryNav__icon primaryNav__icon--salmon fa-fw mr-0050"></i>
      <span class="primaryNav__label">Entity Types</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/connection-types"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-share-alt primaryNav__icon primaryNav__icon--deepsky fa-fw mr-0050"></i>
      <span class="primaryNav__label">Connection Types</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/fields"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-tags primaryNav__icon primaryNav__icon--turquoise fa-fw mr-0050"></i>
      <span class="primaryNav__label">Info</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/assessment"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-sliders-h primaryNav__icon primaryNav__icon--gold fa-fw mr-0050"></i>
      <span class="primaryNav__label">Assessments</span>
    </a>

    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/integrations"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-wrench primaryNav__icon primaryNav__icon--green fa-fw mr-0050"></i>
      <span class="primaryNav__label">API &amp; Integrations</span>
    </a>


    <a class="primaryNav__link"
       *appIfMinRole="'administrator'"
       routerLink="/admin/uploader"
       queryParamsHandling="merge"
       routerLinkActive="primaryNav__link--active"
       #rla="routerLinkActive"
       [active]="rla.isActive"
       mat-tab-link>
      <i class="fal fa-file-upload primaryNav__icon primaryNav__icon--green fa-fw mr-0050"></i>
      <span class="primaryNav__label">Uploads</span>
    </a>

  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

</header>
